// Module
var code = "<header> <h1> <route-link to=/ > <svg id=site-title xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 325 60\"> <text transform=\"translate(0 55.26)\">Grégory Albouy</text> </svg> <span class=subtitle>student Web developer @HETIC</span> </route-link> </h1> </header> ";
// Exports
export default code;